import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ApiService } from 'src/app/api.service';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { mercadoCompania } from 'src/app/interface/mercadoCompania';
import { GestionService } from 'src/app/services/gestion.services';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { Subscription } from 'rxjs';
import { OpeentradaDialogComponent } from '../broker/opeentrada-dialog/opeentrada-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TemaService } from 'src/app/services/tema.services';
import { BrokerService } from 'src/app/services/broker.services';
import { CookieService } from 'ngx-cookie-service';
// MatSnackBar removed; using ToastrService where needed
import { MarketDataService } from '../../services/market-data.service';
import { SseService } from 'src/app/services/SseService';
import { urlMercado } from 'src/app/utils/mercado-url.util';

@Component({
  selector: 'app-tablamercado',
  templateUrl: './tablamercado.component.html',
  styleUrl: './tablamercado.component.scss'
})
export class TablamercadoComponent implements OnInit, OnChanges, OnDestroy {
  private marketDataSubscription: Subscription;
  public licencia: string;

  public mercados: any;
  public panelOpenState: boolean = false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }
  public idMercado: number = 0;
  public idMercadoBroker: number = 0;
  public companiaMercado = new CdkTableVirtualScrollDataSource<mercadoCompania>;
  public BrokerCompMercado = new CdkTableVirtualScrollDataSource<mercadoCompania>;
  public data: any;
  public isGestor: boolean = true;
  public optimawallet: OptimalWallet;
  public subOptimaWallet: Subscription;
  public brokerOptima: OptimalWallet;
  public subbrokerOptima: Subscription;
  public filaSeleccionada: any;
  public queryParams: string;
  public listaCompania: any;
  public listaCompaniaBroker: any;
  public isDark: boolean = false;
  public subTema: Subscription;
  public subCompania: Subscription;
  public subBrokerCompania: Subscription;
  public subGestorCompania: Subscription;
  public subIdCompania: Subscription;
  public subIdBrokCompania: Subscription;
  public actualizarCarteraBroker: Subscription;
  public actualizarCarteraGestor: Subscription;
  public cfd: boolean=false;
  @Input() isBroker: boolean = false;
  @Input() stkcfd: string = '';
  @Input() idcartera: number;
  @Input() metaapi: boolean = false;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestor!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportBroker!: CdkVirtualScrollViewport;
  private marketCountdownInterval: any = null;


  
  tableColumns: TableColmuns[] = [
    { id: 'idnectum', name: 'ID Nectum', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'iso', name: 'Compañia', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'descripcion', name: 'Descripcion', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'fecha', name: 'Fecha', isShow: false, isDate: true, isNumber: false, isString: false },
    { id: 'hora', name: 'Hora', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'precioteorico', name: 'Cotizacion', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'bid', name: 'Bid', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'ask', name: 'Ask', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'variacion', name: 'Variacion', isShow: false, isDate: false, isNumber: true, isString: false },  
    { id: 'stoplosspor', name: '% Stop Loss', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'stoploss', name: 'Stop Loss', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'numcciones', name: 'N° Acciones', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'volumen', name: 'Volumen', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'delay', name: 'Delay', isShow: false, isDate: false, isNumber: false, isString: true },

  ]

  displayedColumns: string[] = ['iso', 'precioteorico', 'bid', 'ask','numcciones', 'stoploss'];

  constructor(private apiService: ApiService,
    private _gestionsv: GestionService,
    public dialog: MatDialog,
    public temaService: TemaService,
    private _brokerService: BrokerService,
    private cdr: ChangeDetectorRef,
    private _cookieService: CookieService, private _sseservice: SseService,
    private marketDataService: MarketDataService,
  ) {
    this.licencia = this._cookieService.get('auth_token');
  }

  private initializeMarketCountdowns(): void {
    if (!Array.isArray(this.mercados)) {
      return;
    }

    this.mercados.forEach((mercado: any) => {
      if (!mercado) {
        return;
      }
      const rawSeconds = mercado?.seconds_until_change;
      if (rawSeconds === null || rawSeconds === undefined) {
        mercado.secondsRemaining = undefined;
        mercado.countdownPrefix = '';
        mercado.countdownLabel = '';
        return;
      }

      const seconds = Math.max(0, Number(rawSeconds));
      const status = mercado?.market_status ?? '';
      const prefix = this.resolveCountdownPrefix(status, seconds);
      mercado.secondsRemaining = seconds;
      mercado.countdownPrefix = prefix;
      const isSpecialMessage = prefix === 'Se abre mañana' || prefix === 'Se abre el lunes';
      mercado.countdownLabel = prefix ? (isSpecialMessage ? prefix : `${prefix} ${this.formatSeconds(seconds)}`) : '';
    });

    if (this.marketCountdownInterval) {
      clearInterval(this.marketCountdownInterval);
      this.marketCountdownInterval = null;
    }

    if (this.mercados.some((mercado: any) => mercado?.countdownPrefix)) {
      this.marketCountdownInterval = setInterval(() => this.tickMarketCountdowns(), 1000);
    }

    this.cdr.markForCheck();
  }

  private tickMarketCountdowns(): void {
    if (!Array.isArray(this.mercados) || !this.mercados.length) {
      return;
    }

    let shouldMark = false;

    this.mercados.forEach((mercado: any) => {
      if (!mercado) {
        return;
      }

      const prefix = this.resolveCountdownPrefix(mercado.market_status, mercado.secondsRemaining);
      if (!prefix || mercado.seconds_until_change === null || mercado.seconds_until_change === undefined) {
        if (mercado.countdownLabel) {
          mercado.countdownPrefix = '';
          mercado.countdownLabel = '';
          mercado.secondsRemaining = 0;
          shouldMark = true;
        }
        return;
      }

      if (typeof mercado.secondsRemaining !== 'number') {
        mercado.secondsRemaining = Math.max(0, Number(mercado.seconds_until_change ?? 0));
      }

      if (mercado.secondsRemaining > 0) {
        mercado.secondsRemaining -= 1;
        shouldMark = true;
      } else if (mercado.secondsRemaining < 0) {
        mercado.secondsRemaining = 0;
        shouldMark = true;
      }

      if (prefix) {
        // Si es mensaje especial (no 'Abre en' ni 'Cierra en'), no mostrar countdown de horas
        const isSpecialMessage = prefix === 'Se abre mañana' || prefix === 'Se abre el lunes';
        const countdownLabel = isSpecialMessage ? prefix : `${prefix} ${this.formatSeconds(mercado.secondsRemaining)}`;
        if (countdownLabel !== mercado.countdownLabel) {
          mercado.countdownLabel = countdownLabel;
          shouldMark = true;
        }
        mercado.countdownPrefix = prefix;
      } else if (mercado.countdownLabel) {
        mercado.countdownLabel = '';
        mercado.countdownPrefix = '';
        shouldMark = true;
      }
    });

    if (shouldMark) {
      this.cdr.markForCheck();
    }
  }

  private resolveCountdownPrefix(status: string, secondsUntilChange?: number): string {
    if (!status) {
      return '';
    }
    const normalized = status.toUpperCase();
    if (normalized === 'OPEN') {
      return 'Cierra en';
    }
    if (normalized === 'CLOSED') {
      return this.resolveClosedMarketLabel(secondsUntilChange);
    }
    return '';
  }

  private resolveClosedMarketLabel(secondsUntilChange?: number): string {
    if (secondsUntilChange === null || secondsUntilChange === undefined) {
      return 'Abre en';
    }

    const now = new Date();
    const openTime = new Date(now.getTime() + (secondsUntilChange * 1000));
    const currentDay = now.getDay(); // 0 = domingo, 1 = lunes, ..., 5 = viernes, 6 = sábado

    // Si el mercado abre hoy, mostrar countdown
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const openDayStart = new Date(openTime.getFullYear(), openTime.getMonth(), openTime.getDate());
    
    if (openDayStart.getTime() === todayStart.getTime()) {
      // El mercado abre hoy, mostrar countdown con horas
      return 'Abre en';
    }

    // Si estamos en viernes (5), sábado (6) o domingo (0), mostrar "Se abre el lunes"
    if (currentDay === 5 || currentDay === 6 || currentDay === 0) {
      return 'Se abre el lunes';
    }

    // Si el mercado abre mañana (día diferente pero no es fin de semana)
    return 'Se abre mañana';
  }

  private formatSeconds(totalSeconds: number): string {
    const safeSeconds = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(safeSeconds / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const seconds = safeSeconds % 60;

    const pad = (value: number) => value.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  getCountdownLabel(id: number): string {
    if (!Array.isArray(this.mercados)) {
      return '';
    }
    const mercado = this.mercados.find((item: any) => item?.idmercado === id);
    return mercado?.countdownLabel ?? '';
  }

  /** Abre el activo en /mercados dentro del mercado de la tabla. */
  urlMercadoActivo(idmercado: number, item: any): string {
    const mercado = Array.isArray(this.mercados) ? this.mercados.find((m: any) => m?.idmercado === idmercado) : null;
    return mercado ? urlMercado(mercado, item?.iso ?? '') : '/mercados';
  }

  /** Referencia estable para pasar getCountdownLabel a <app-mercado-select>. */
  readonly countdownLabelFn = (id: number): string => this.getCountdownLabel(id);

  /** Se cachea (no getter): ng-select reinicia el desplegable cada vez que [items]
   *  cambia de referencia, y el countdown/tiempo real disparan detección cada segundo. */
  public mercadosFiltrados: any[] = [];

  private actualizarMercadosFiltrados(): void {
    if (!Array.isArray(this.mercados)) {
      this.mercadosFiltrados = [];
    } else if (!this.isBroker) {
      this.mercadosFiltrados = this.mercados;
    } else {
      this.mercadosFiltrados = this.mercados.filter((m: any) => !!m?.metaapi === this.metaapi);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['metaapi'] || changes['isBroker']) {
      this.actualizarMercadosFiltrados();
    }
  }


  ngOnInit(): void {
    
     this.marketDataSubscription = this.marketDataService.marketData$.subscribe(
          data => {
            if (data) {
              this.updateMarketData(data);
              this.initializeMarketCountdowns();
            }
          }
        );
    this.apiService.apiPost("listamercados", true, {}, 2).then((response) => {
      if (response.data) {
        this.mercados = response.data;
        this.actualizarMercadosFiltrados();
        this.initializeMarketCountdowns();
      }
    });
    this.subTema = this.temaService.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
      }
    });

    this.subOptimaWallet = this._gestionsv.valgestOptimaWallet$.subscribe({
      next: (data: any) => {
        this.optimawallet = data;
        if(this.optimawallet.nombre){
          this.buscarCompania();
        }
      }
    });

    this.subCompania = this._gestionsv.valgestcompaniaMercado$.subscribe({
      next: (data: any) => {
        this.companiaMercado = new CdkTableVirtualScrollDataSource(data);
      }
    });
    this.subIdCompania = this._gestionsv.valgestidMercado$.subscribe({
      next: (data: any) => {
        this.idMercado = data;
       // this.buscarCompania();
       console.log("this._gestionsv.valgestidMercado$.subscribe ",this.idMercado );
      }
    });
    this.subGestorCompania = this._gestionsv.valgestcompaniaMercado$.subscribe({
      next: (data: any) => {
        //console.log("QUE ESTA LLEGANDO A TABLA MERCADO ", data);
        this.companiaMercado = new CdkTableVirtualScrollDataSource(this.flattenArray(data));
        this.actualizarViewport();
      }
    });
    this.actualizarCarteraGestor = this._gestionsv.valactualizarCartera$.subscribe({
      next: (data: any) => {
        if (data) {
          let optimaTemp:any;
          optimaTemp = this._gestionsv.getOptimaWallet();
          this.optimawallet = optimaTemp;
          this.buscarCompania();
        }
      }
    });
    //----------------------BROKER ----------------------
    this.subbrokerOptima = this._brokerService.valBrokOptimaWallet$.subscribe({
      next: (data: any) => {
          this.brokerOptima = data;
          if(this.brokerOptima.nombre){
            // Sync idMercadoBroker from the wallet so buscarCompania() uses the correct market
            if (data?.idmercado) {
              this.idMercadoBroker = data.idmercado;
            }
            this.buscarCompania(); 
          }
      }
    });

    this.subIdBrokCompania = this._brokerService.valBrokidMercado$.subscribe({
      next: (data: any)=>{
        this.idMercadoBroker = data;
       // this.buscarCompania();
        //console.log(" this._brokerService.valBrokidMercado$ ",this.idMercadoBroker );
      }
    });
    this.subBrokerCompania = this._brokerService.valBrokCompania$.subscribe({
      next: (data: any) => {
        this.BrokerCompMercado = new CdkTableVirtualScrollDataSource(this.flattenArray(data));
        this.actualizarViewport();
        //console.log("this.subBrokerCompaniathis.subBrokerCompania ", data);
      }
    });

    this.actualizarCarteraBroker = this._brokerService.valactualizarCartera$.subscribe({
      next: (data: any) => {
        if (data) {
          let optimaTemp:any;
          optimaTemp = this._brokerService.getOptimaWallet();
          this.brokerOptima = optimaTemp;
          this.buscarCompania();
          //console.log("actualizarCarteraBroker actualizarCarteraBroker", data)
        }
      }
    });
   // this.buscarCompania();
  //  this.gestcarterabyid();
/**
    let dataJson = {
      idcartera: this.idcartera
    };
    console.log(this.idcartera);
    this._sseservice.apiPostNew('getCarteraById', dataJson, this.licencia).subscribe({
      next: (data: any) => {
        console.log(data.cartera);
        if(!this.isBroker)
        this.idMercado = data.cartera.idmercado;
        else
        this.idMercadoBroker = data.cartera.idmercado;
        // Asegúrate de que el select se actualice
        this.cdr.detectChanges();
      }
    });*/
  }

  gestcarterabyid(idmercado: number) {
    /**let dataJson = {
      idcartera: this.idcartera
    };
    console.log(this.idcartera);
    this._sseservice.apiPostNew('getCarteraById', dataJson, this.licencia).subscribe({
      next: (data: any) => {
        console.log(data.cartera);
        if(!this.isBroker) {
          this.idMercado = data.cartera.idmercado;
        } else {
          this.idMercadoBroker = data.cartera.idmercado;
        }
        // Asegúrate de que el select se actualice
        this.cdr.detectChanges();
      }
    });*/
    if(!this.isBroker) {
      this.idMercado = idmercado;
    } else {
      this.idMercadoBroker = idmercado;
    }
    // Asegúrate de que el select se actualice
    this.cdr.detectChanges();
    this.buscarCompania();
  //}
  }
  
  toggleColumnVisibility(id: any) {
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
    }
  }

  // Estado de orden actual
  sortStateGestor: { active: string | null, direction: 'asc' | 'desc' | '' } = { active: null, direction: '' };
  sortStateBroker: { active: string | null, direction: 'asc' | 'desc' | '' } = { active: null, direction: '' };

  // Llama a estos métodos después de actualizar los arrays (datos en tiempo real)
  applySortGestor(): void {
    const data = this.companiaMercado?.data ?? [];
    const sorted = this.getSortedArray(data, this.sortStateGestor);
    this.companiaMercado = new CdkTableVirtualScrollDataSource(sorted);
    this.actualizarViewport();
  }
  applySortBroker(): void {
    const data = this.BrokerCompMercado?.data ?? [];
    const sorted = this.getSortedArray(data, this.sortStateBroker);
    this.BrokerCompMercado = new CdkTableVirtualScrollDataSource(sorted);
    this.actualizarViewport();
  }

  orderByGestor(columnId: string): void {
    this.sortStateGestor = this.nextSortState(this.sortStateGestor, columnId);
    this.applySortGestor();
  }
  orderByBroker(columnId: string): void {
    this.sortStateBroker = this.nextSortState(this.sortStateBroker, columnId);
    this.applySortBroker();
  }

  private nextSortState(
    prev: { active: string | null, direction: 'asc' | 'desc' | '' },
    columnId: string
  ) {
    // ciclo: asc -> desc -> sin orden
    let direction: 'asc' | 'desc' | '';
    if (prev.active !== columnId) {
      direction = 'asc';
    } else {
      direction = prev.direction === 'asc' ? 'desc' : (prev.direction === 'desc' ? '' : 'asc');
    }
    return { active: direction ? columnId : null, direction };
  }

  private getSortedArray<T = any>(
    data: T[],
    state: {active: string | null, direction: 'asc'|'desc'|''}
  ): T[] {
    if (!Array.isArray(data) || !state.active || !state.direction) return [...(data || [])];

    const meta = this.tableColumns?.find(c => c.id === state.active);
    const factor = state.direction === 'asc' ? 1 : -1;
    const col = state.active as string;

    const accessor = (row: any) => {
      if (col === 'hora') {
        return row?.['fecha'] ? new Date(row['fecha']).getTime() : null;
      }
      const v = row?.[col];
      if (meta?.isDate) return v ? new Date(v).getTime() : null;
      if (meta?.isNumber) return v != null && v !== '' ? Number(v) : null;
      return (v ?? '').toString().toLowerCase();
    };

    return [...data].sort((a: any, b: any) => {
      const va = accessor(a);
      const vb = accessor(b);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;   // null/undefined al final
      if (vb == null) return -1;
      if (va < vb) return -1 * factor;
      if (va > vb) return  1 * factor;
      return 0;
    });
  }

  // Reaplicar orden cuando llegan datos nuevos
  private onRealtimeUpdateGestor(rows: any[]) {
    const sorted = this.getSortedArray(rows, this.sortStateGestor);
    this.companiaMercado = new CdkTableVirtualScrollDataSource(sorted);
    this.actualizarViewport();
  }
  private onRealtimeUpdateBroker(rows: any[]) {
    const sorted = this.getSortedArray(rows, this.sortStateBroker);
    this.BrokerCompMercado = new CdkTableVirtualScrollDataSource(sorted);
    this.actualizarViewport();
  }
  sortByvolumendDesc(dataArray: any[]): any[] {
    return dataArray.sort((a, b) => {
      return b.volumen - a.volumen;
    });
  }

  sortByisorDesc(dataArray: any[]): any[] {
    return dataArray.sort((a, b) => {
      return a.iso.localeCompare(b.iso);
    });
  }

  buscarCompania() {
    console.log("SE EJECUTO buscarCompania()");
    if (!Array.isArray(this.mercados)) {
      return;
    }
    let jsonData;
    const mercadoEncontrado = this.mercados.find((mercado: { idmercado: number; sectype:string }) => mercado.idmercado === this.idMercado);
    if (mercadoEncontrado) {
      console.log("MERCADO ENCONTRADO", mercadoEncontrado);
      this.stkcfd = mercadoEncontrado.sectype;
    } else {
      console.log("MERCADO NO ENCONTRADO");
    }
   
   console.log("this.brokerOptima.nombre ",this.brokerOptima.nombre+ this.stkcfd);

    if (!this.isBroker && this.optimawallet.nombre ) {
      jsonData = {
        idmercado: this.idMercado, broker: false, cfd:(this.stkcfd == 'CFD'), metaapi: false
      };
      for (let i = 0; i < this.mercados.length; i++) {
        console.log("mercados[i].idmercado ", this.mercados[i].idmercado+ ' '+ this.idMercado);
        if(this.mercados[i].idmercado == this.idMercado){
          this.stkcfd = this.mercados[i].sectype;
          console.log("this.stkcfd ", this.stkcfd);
        }
      }
     
      if(this.idMercado){
        this.apiService.apiPost("listadecompaniaspormercado?broker=false&cfd="+(this.stkcfd == 'CFD'), true, jsonData, 2).then((response) => {
          if (!this.isBroker) {
            let companiaData = this.calculoCompanias(response.data, this.optimawallet);
            this.listaCompania = companiaData;
            this._gestionsv.updatecompaniaMercado(companiaData);
            this._gestionsv.updategestidMercado(this.idMercado);
            let gestorIdnectumsArray = this.listaCompania.slice(0, 30).map((c: any) => c.idNectum).filter((id: number) => id != null);
            this._gestionsv.updategestorIdnectumsArray(gestorIdnectumsArray);
          } 
        });
      }
      
    } else if (this.isBroker && this.brokerOptima.nombre) {
        jsonData = {
          idmercado: this.idMercadoBroker, broker: true, cfd:(this.stkcfd == 'CFD'), metaapi: this.metaapi
        };
       
         for (let i = 0; i < this.mercados.length; i++) {
          // console.log("mercados[i].idmercado ", this.mercados[i].idmercado+ ' '+ this.idMercadoBroker);
           if(this.mercados[i].idmercado == this.idMercadoBroker){
             this.stkcfd = this.mercados[i].sectype;
             console.log("this.stkcfd ", this.stkcfd);        
             this._brokerService.updateStkcfd(this.stkcfd);

           }
         }
        this.apiService.apiPost("listadecompaniaspormercado", true, jsonData, 2).then((response) => {
            const aplicarCalculo = (symbolSpecMap?: Map<number, { contractSize: number; minVolume: number; volumeStep: number }>) => {
              let companiaData = this.calculoCompanias(response.data, this.brokerOptima, symbolSpecMap);
              this.listaCompaniaBroker=companiaData;
              this._brokerService.updateBrokcompaniaMercado(companiaData);
              this._brokerService.updatebrokidMercado(this.idMercadoBroker);
              let gestorIdnectumsArray = this.listaCompaniaBroker.slice(0, 30).map((c: any) => c.idNectum).filter((id: number) => id != null);
              this._brokerService.updategestorIdnectumsArray(gestorIdnectumsArray);
              console.log("gestorIdnectumsArray ", gestorIdnectumsArray);
            };

            if (this.metaapi) {
              this._sseservice.apiPostNew('metaapi/listadecontractsize', { idmercado: this.idMercadoBroker }, this.licencia).subscribe({
                next: (specs: any) => {
                  const symbolSpecMap = new Map<number, { contractSize: number; minVolume: number; volumeStep: number }>(
                    (specs || []).map((s: any) => [Number(s.idnectum), {
                      contractSize: Number(s.contract_size),
                      minVolume: Number(s.min_volume),
                      volumeStep: Number(s.volume_step)
                    }])
                  );
                  aplicarCalculo(symbolSpecMap);
                },
                error: () => aplicarCalculo()
              });
            } else {
              aplicarCalculo();
            }
      });
    }
 
    let  dataJson = {
      idcartera: this.idcartera,
      idmercado: this.isBroker ? this.idMercadoBroker : this.idMercado
    };
    this._sseservice.apiPostNew('actualizarMercadoCartera', dataJson, this.licencia).subscribe({
      next: (data: any) => {
        console.log("actualizarMercadoCartera actualizarMercadoCartera", data)
      }
    });
//    cuando se tenga lista companialista enviar los primeros 30 registro a gestor idnectumsArray

    
  }

  private calcularStoplossYAcciones(
    precioteorico: number,
    stopLossPct: number,
    riesgo: number,
    tiporiesgo: string,
    bajista: boolean,
    contractSize: number,
    metaapi: boolean,
    participacion: boolean,
    minVolume: number,
    volumeStep: number
  ): { stoploss: number; nacciones: number } {
    const cs = contractSize || 1;
    const stoploss = bajista
      ? precioteorico + (precioteorico * stopLossPct) / 100
      : precioteorico - (precioteorico * stopLossPct) / 100;

    let nacciones = 0;
    if (tiporiesgo === 'LIMITADO') {
      const distancia = Math.abs(precioteorico - stoploss);
      nacciones = distancia > 0 ? riesgo / (cs * distancia) : 0;
    } else {
      nacciones = riesgo / (cs * precioteorico);
    }

    if (metaapi) {
      nacciones = Math.round(nacciones * 100) / 100;
      if (minVolume && nacciones < minVolume) {
        nacciones = minVolume;
      } else if (volumeStep && volumeStep > 0) {
        const remainder = nacciones % volumeStep;
        if (remainder !== 0)
          nacciones = nacciones - remainder;
      }
    } else if (!participacion) {
      nacciones = Math.floor(nacciones);
    }

    return { stoploss, nacciones };
  }

  calculoCompanias(data: any, cartera: any, symbolSpecMap?: Map<number, { contractSize: number; minVolume: number; volumeStep: number }>) {
    const dataWithTotal = data.map((item: any) => {
      const spec = symbolSpecMap?.get(Number(item.idNectum));
      const cs = spec?.contractSize ?? 1;
      const minVolume = spec?.minVolume ?? 0;
      const volumeStep = spec?.volumeStep ?? 0;
      const { stoploss, nacciones } = this.calcularStoplossYAcciones(
        item.precioteorico, cartera.stopLoss, cartera.riesgo, cartera.tiporiesgo, cartera.bajista,
        cs, this.metaapi, cartera.participacion, minVolume, volumeStep
      );

      return {
        ...item, numcciones: nacciones, stoplosspor: cartera.stopLoss, stoploss: stoploss,
        contractsize: cs, minvolume: minVolume, volumestep: volumeStep
      };//20 es %stoploss
    });
    return dataWithTotal;
  }

  flattenArray(arrayOfArrays: any[]): any[] {

    return arrayOfArrays.flatMap(innerArray => innerArray);
  }
  
  openDialog(): void {
    let optimaWallet;
    let listaCompania;
    console.log("VALOR DE IS BROKER: ", this.isBroker);
    if(this.isBroker){
      optimaWallet = this.brokerOptima;
      listaCompania = this.listaCompaniaBroker
    }else{
      optimaWallet = this.optimawallet;
      listaCompania = this.listaCompania;
    }
    console.log("CARTERA ENVIADA: ", optimaWallet);
    console.log("LISTA ENVIADA: ", listaCompania);
    const newcompania = JSON.parse(JSON.stringify(this.filaSeleccionada));
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const showWhatIf = this.isBroker && optimaWallet?.tipoBroker !== 'METAAPI';
    const dialogRef = this.dialog.open(OpeentradaDialogComponent, {
      width: showWhatIf ? '43.75%' : '25%',
      maxHeight: '90vh',
      panelClass: dialogClass,
      data: {
        optimaWallet: optimaWallet,
        compania: newcompania,
        listaCompnia: listaCompania, 
        isBroker: this.isBroker,
        stkcfd: this.stkcfd
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró', result);
    });
  }

  actualizarViewport() {

    if (this.viewportGestor) {
      //console.log("actualizo el viewport");
      this.viewportGestor.checkViewportSize();
      this.viewportGestor.checkViewportSize();
    }else if(this.viewportBroker){
      this.viewportBroker.checkViewportSize();
      this.viewportBroker.checkViewportSize();

    }
    this.cdr.detectChanges();
  }

  verGrafica() {
    const jsonData = {
      idNectum: this.filaSeleccionada.idNectum,
      nombreComp: this.filaSeleccionada.iso,
      idModelo: this.optimawallet.idcartera.toString(),
      isModelo: 'grafica'
    };
    this.queryParams = new URLSearchParams(jsonData).toString();
    console.log(this.queryParams);
    //window.open('/grafica-modelo/'+this.queryParams ,'_blank');

  }


updateMarketData(data: any) {
  // Seleccionar la lista correcta según el contexto
  const targetList = this.isBroker ? this.listaCompaniaBroker : this.listaCompania;
  
  if (targetList && targetList.length > 0) {
    const index = targetList.findIndex((item: { idNectum: number }) => item.idNectum === data.idnectum);
    
    if (index !== -1) {
      //console.log('Actualizando datos en tiempo real:', data);

      // Modificar algunos valores manualmente
      const updatedData = { ...data };
      updatedData.precioteorico = Number(data.close).toFixed(2);
      updatedData.fecha = new Date();
      
      // Solo actualizar bid si no es 0
      if (data.bid && Number(data.bid) !== 0) {
        updatedData.bid = data.bid;
      } else {
        updatedData.bid = targetList[index].bid; // Mantener valor anterior
      }
      
      // Solo actualizar ask si no es 0
      if (data.ask && Number(data.ask) !== 0) {
        updatedData.ask = data.ask;
      } else {
        updatedData.ask = targetList[index].ask; // Mantener valor anterior
      }
      
      // Calcular y agregar nuevos campos
      const cartera = this.isBroker ? this.brokerOptima : this.optimawallet;
      const cs = targetList[index].contractsize ?? 1;
      const minVolume = targetList[index].minvolume ?? 0;
      const volumeStep = targetList[index].volumestep ?? 0;
      const { stoploss, nacciones } = this.calcularStoplossYAcciones(
        Number(updatedData.precioteorico), targetList[index].stoplosspor, cartera.riesgo, cartera.tiporiesgo, cartera.bajista,
        cs, this.metaapi, cartera.participacion, minVolume, volumeStep
      );
      updatedData.stoploss = Number(stoploss).toFixed(2);
      updatedData.numcciones = nacciones;

      // Actualizar la fila con los datos modificados
      targetList[index] = { ...targetList[index], ...updatedData };
    }

    // Actualizar el DataSource y servicio correspondiente
    if (this.isBroker) {
      this.listaCompaniaBroker = targetList;
      this.BrokerCompMercado = new CdkTableVirtualScrollDataSource(this.listaCompaniaBroker);
      this._brokerService.updateBrokcompaniaMercado(this.listaCompaniaBroker);
      if (this.sortStateBroker.active) this.applySortBroker();
    } else {
      this.listaCompania = targetList;
      this.companiaMercado = new CdkTableVirtualScrollDataSource(this.listaCompania);
      this._gestionsv.updatecompaniaMercado(this.listaCompania);
      if (this.sortStateGestor.active) this.applySortGestor();
    }
    this.actualizarViewport();
  }
}




  selectRow(row: any) {
    this.filaSeleccionada = row;
  }

  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
    console.log(this.filaSeleccionada);
  }

  ngOnDestroy(): void {
    this.subTema.unsubscribe();
    this.subCompania.unsubscribe();
    this.subOptimaWallet.unsubscribe();
    this.subIdCompania.unsubscribe();
    this.subbrokerOptima.unsubscribe();
    this.subBrokerCompania.unsubscribe();
    this.actualizarCarteraBroker.unsubscribe();
    this.subGestorCompania.unsubscribe();
    this.subIdCompania.unsubscribe();
    this.subIdBrokCompania.unsubscribe();
    if (this.marketDataSubscription) {
      this.marketDataSubscription.unsubscribe();
    }
    if (this.marketCountdownInterval) {
      clearInterval(this.marketCountdownInterval);
      this.marketCountdownInterval = null;
    }
  }



}
